var React = require('react');

function OnDemand (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.5","y":"1.5","width":"11","height":"9","rx":"1.5","stroke":"currentColor","key":0}),React.createElement("line",{"x1":"3.5","y1":"13.5","x2":"12.5","y2":"13.5","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M7 7.13841V4.86159C7 4.47768 7.41474 4.23699 7.74807 4.42747L9.74029 5.56588C10.0762 5.75783 10.0762 6.24217 9.74029 6.43412L7.74807 7.57253C7.41474 7.76301 7 7.52232 7 7.13841Z","fill":"currentColor","key":2})]);
}

OnDemand.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = OnDemand;

OnDemand.default = OnDemand;
